'use client'

import { Button } from '@snowball-tech/fractal/dist/src/components/Button'

import { useState } from 'react'

import isEmpty from 'lodash/fp/isEmpty'
import isFunction from 'lodash/fp/isFunction'

import { Apps } from '../enums'
import { getSignupUrl } from '../helpers/navigation'
import useTranslations from '../hooks/useTranslations'
import SubscribeForm from './SubscribeForm'

type Props = {
  app?: Apps
  editionUuid?: string
  redirectOnSuccess?: boolean
  reloadOnSuccess?: boolean
  returnUrl?: string
  withForm?: boolean
  onStartSubscribe?: () => void
  onSubmit?: () => void
  onSubmitted?: () => void
}
export default function SubscribeButton({
  app = Apps.Media,
  editionUuid,
  onStartSubscribe,
  onSubmit,
  onSubmitted,
  redirectOnSuccess,
  reloadOnSuccess,
  returnUrl,
  withForm = true,
}: Props) {
  const $t = useTranslations()

  const [showSignupForm, setShowSignupForm] = useState(false)

  const handleStartSubscribe = () => {
    if (withForm) {
      setShowSignupForm(true)
    }

    if (isFunction(onStartSubscribe)) {
      onStartSubscribe()
    }
  }

  return withForm && showSignupForm ? (
    <SubscribeForm
      buttonPosition="inline"
      darkSeparator
      editionUuid={editionUuid}
      iconOnly
      label={false}
      origin="free_subscribe"
      redirectOnSuccess={redirectOnSuccess}
      reloadOnSuccess={reloadOnSuccess}
      returnUrl={returnUrl}
      onSubmit={onSubmit}
      onSubmitted={onSubmitted}
    />
  ) : (
    <Button
      href={
        withForm
          ? undefined
          : getSignupUrl(
              app,
              returnUrl,
              isEmpty(editionUuid) ? '' : `from=${editionUuid}&source=media`,
            )
      }
      label={$t('subscribe.cta.label')}
      variant="display"
      onClick={handleStartSubscribe}
    />
  )
}
